"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidJson = void 0;
function isValidJson(str) {
    try {
        if (typeof str !== 'string') {
            return str;
        }
        const parsed = JSON.parse(str);
        return parsed;
    }
    catch (e) {
        return null;
    }
}
exports.isValidJson = isValidJson;
//# sourceMappingURL=productUtilities.js.map